<!-- Gate Pass Table View -->

<template>
  <b-container fluid class="p-3">
    <b-row class="p-3" v-if="skeletonloading">
      <b-col>
        <SkeletonTableLoader :columns="headers" :loading="skeletonloading" />
      </b-col>
    </b-row>
    <b-row v-else>
      <b-col>
        <Tableview
          :value="list"
          :paginator="true"
          class="p-datatable-gridlines commonstatusclass"
          :rows="10"
          :rowHover="true"
          filterDisplay="menu"
          responsiveLayout="scroll"
          :columns="headers"
          @row-click=""
          :globalFilterFields="globalFilterFields"
          :filters="filters"
          @ShowRows=""
          :exceldownload="true"
          :filterbtn="true"
          :statusFilterBtn="true"
        >
          <template v-slot:Add>
            <span class="add">
              <AddButton
                :btnname="$t('btn.plusaddnew')"
                class="float-rights my-3"
                @click="OpenSidebar('')"
              />
            </span>
          </template>
          <template v-slot:Status="{ data }">
            <OrangeStatus name="OUT" v-if="data.Status == 1" />
            <GreenStatus name="IN" v-if="data.Status == 2" />
          </template>
          <template v-slot:action="{ data }">
            <span>
              <Button
                icon="pi pi-ellipsis-v"
                class="p-button-rounded editicon p-button-text"
                @click="toggle($event, data)"
              />
            </span>
          </template>
        </Tableview>
      </b-col>
    </b-row>
  </b-container>
  <Dialog
    v-model:visible="popupVisible"
    modal
    header="Remarks"
    :style="{ width: '30rem' }"
    :closable="false"
  >
    <b-form @submit.prevent="approveAction">
      <div class="field">
        <CustomTextArea
          id="GatePassRemarks"
          v-model="closeGatepass.remarks"
          placeholder="Enter your remarks"
          name="Remarks"
          :rules="{}"
        />
      </div>
      <div class="d-flex flex-row-reverse h-100 align-items-end">
        <Footer
          @cancel="popupVisible = false"
          label="Approve"
          cancelhide="false"
          CancelLabel="Cancel"
          :cancelhide="false"
        />
      </div>
    </b-form>
  </Dialog>
  <Menu ref="menu" id="overlay_menu" :model="actionlist" :popup="true" />
  <GatePassRightSidebar
    :trigger="CommonObject.sidebaropen"
    :tableId="CommonObject.Id"
    @closedetailsrightsidebar="CloseSidebar()"
  />
</template>

<script lang="ts">
import { defineComponent, onMounted, ref, computed } from "vue";
import { useRouter, useRoute } from "vue-router";
import { useI18n } from "vue-i18n";
import SkeletonTableLoader from "../../../../../../../components/FormComponents/SkeletonTableLoader.vue";
import { FilterMatchMode, FilterOperator } from "primevue/api";
import Tableview from "../../../../../../../components/FormComponents/Table.vue";
import GatePassService from "../../../../../../../modules/Inventory/Service/AssetManagement/GatePassService";
import GatePassRightSidebar from "./GatePassRightSidebar.vue";
import CustomTextArea from "../../../../../../../components/FormComponents/TextArea.vue";
import Dialog from "primevue/dialog";
import Footer from "../../../../../../../components/FormComponents/Footer.vue";
import { useForm } from "vee-validate";

import Button from "primevue/button";

export default defineComponent({
  components: {
    SkeletonTableLoader,
    Tableview,
    GatePassRightSidebar,
    CustomTextArea,
    Footer,
  },

  setup() {
    const { t } = useI18n();
    const skeletonloading = ref(false);
    const router = useRouter();
    const routes = useRoute();
    const tableId = ref();
    const menu = ref();
    const list = ref<any[]>([]);
    const { handleSubmit, resetForm, validate } = useForm();

    const ParamValues = ref({
      StoreId: Number(routes.query.Id ?? 0),
      BranchId: Number(routes.query.BranchId ?? 0),
    });

    const popupVisible = ref(false);
    const closeGatepass = ref({
      remarks: "",
    });
    let GatePassvisible = ref(false);

    async function approveAction() {
      const results = await validate();
      if (results.valid) {
        popupVisible.value = false;

        GatePassService.closeGatePass({
          Id: CommonObject.value.Id,
          Remarks: closeGatepass.value.remarks,
        })
          .then((res) => console.log("Response:", res))
          .catch((err) => console.error(err));
      }
    }

    let CommonObject = ref({
      Id: "",
      sidebaropen: false,
    });

    let SessionUserData = localStorage.getItem("UsersData");
    let usersData;
    if (SessionUserData !== null) {
      usersData = JSON.parse(SessionUserData);
    }
    let SessionRoleData = localStorage.getItem("RolesData");
    let RolesData;
    if (SessionRoleData !== null) {
      RolesData = JSON.parse(SessionRoleData);
    }
    let isAdmin = usersData.Admin;
    const headers = ref([
      {
        header: t("assetManagement.gatepass.sno"),
        field: "RowNumber",
        class: "filterdisplaynone",
      },
      {
        header: t("assetManagement.gatepass.service"),
        field: "ServiceCode",
        sortable: false,
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "mediumwidth",
        bodyclass: "boldclass text_overflow2",
      },
      {
        header: t("assetManagement.gatepass.itemname"),
        field: "AssetName",
        sortable: false,
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "mediumwidth",
        bodyclass: "boldclass text_overflow2",
      },
      {
        header: t("assetManagement.gatepass.frombranch"),
        field: "FromStoreBranchName",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "smallwidth",
      },
      {
        header: t("assetManagement.gatepass.tobranch"),
        field: "ToStoreBranchName",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "smallwidth",
      },
      {
        header: t("assetManagement.gatepass.supplier"),
        field: "SupplierCode",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "smallwidth",
      },
      {
        header: t("assetManagement.gatepass.personname"),
        field: "PersonName",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "smallwidth",
      },
      {
        header: t("assetManagement.gatepass.status"),
        field: "Status",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "smallwidth",
        slot: "Status",
        fieldDisplay: "false",
      },
      {
        field: "action",
        header: "",
        slot: "action",
        frozencolumn: true,
        sortable: false,
        hide: false,
        class: "filterdisplaynone last-column-position",
        fieldDisplay: "false",
      },
    ]);

    const globalFilterFields = ref(headers.value.map((col) => col.field));

    const filters = {
      global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      assetName: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: list,
      },
      maintenanceType: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: list,
      },
      SupplierCode: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: list,
      },
      FromStore: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: list,
      },
      ExpectedReturnDate: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: list,
      },
      Priority: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: list,
      },
      CostEstimate: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: list,
      },
      Reason: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: list,
      },
      Status: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: list,
      },
    };

    const toggle = (event, data) => {
      CommonObject.value.Id = data.ID;
      menu.value.toggle(event);
      debugger;
      if (data.Status == 1) {
        GatePassvisible.value = true;
      } else {
        GatePassvisible.value = false;
      }
    };

    const actionlist = computed(() => [
      {
        items: [
          {
            label: "Edit",
            icon: "pi pi-pencil",
            visible: true,
            command: async () => {
              OpenSidebar(CommonObject.value.Id);
            },
          },
          {
            label: "IN",
            icon: "pi pi-pencil",
            visible: GatePassvisible.value,
            command: async () => {
              CloseGatePass(CommonObject.value.Id);
            },
          },
        ],
      },
    ]);
    onMounted(() => {
      IsShow();
    });

    async function IsShow() {
      debugger;
      try {
        let roleId;
        if (isAdmin !== 1) {
          roleId = RolesData.RoleId;
        } else {
          roleId = 0;
        }
        let count = 0;
        skeletonloading.value = true;
        const dataresponse = await GatePassService.listGatePass();
        list.value = dataresponse["result"].map((item) => {
          count = count + 1;
          // Add RowNumber
          item.RowNumber = count;
          return item;
        });
        skeletonloading.value = false;
      } catch (error) {
        console.log(error);
      }
    }

    function OpenSidebar(Id) {
      debugger;
      CommonObject.value.sidebaropen = true;
      CommonObject.value.Id = Id ? Id : "";
    }

    function CloseSidebar() {
      CommonObject.value.sidebaropen = false;
      CommonObject.value.Id = "";
    }

    function CloseGatePass(Id) {
      popupVisible.value = true;
    }

    return {
      skeletonloading,
      ParamValues,
      t,
      headers,
      globalFilterFields,
      list,
      filters,
      CommonObject,
      CloseSidebar,
      toggle,
      menu,
      actionlist,
      tableId,
      IsShow,
      OpenSidebar,
      popupVisible,
      approveAction,
      closeGatepass,
      GatePassvisible,
    };
  },
});
</script>

<style scoped>
.btnTab {
  all: unset;
  background-color: #ffffff;
  color: #4361ee;
  border-radius: 5px;
  border: 1px solid #e1e1e1;
  padding: 10px 12px;
}

.btnPosition {
  position: absolute;
  top: 15px;
  left: 20px;
  display: flex;
  z-index: 9;
}

.btnactiveTab {
  background-color: #4361ee;
  color: #ffffff;
}

.action-button {
  width: 100%;
  height: 100%;
  display: flex !important;
  align-items: center !important;
  justify-content: flex-start !important;
  padding: 0.55rem 1rem !important;
  border-radius: 8px !important;
  font-weight: 500 !important;
  transition: all 0.3s ease !important;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1) !important;
  text-align: left !important;
  font-size: 0.85rem !important;
  background-color: #e7e7e7 !important;
  border-color: #e9e9e9 !important;
  color: #444 !important;
  text-shadow: 0 1px 1px rgba(0, 0, 0, 0.2) !important;
}

.action-button:hover {
  transform: translateY(-2px) !important;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15) !important;
}

.action-button i {
  margin-right: 0.5rem !important;
  font-size: 1rem !important;
}
</style>
